import { SET_DRAWER_OPEN } from '../constants/action-types';

const initialState = {
  drawerOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DRAWER_OPEN:
      return { ...state, drawerOpen: action.drawerOpen };
    default:
      return state;
  }
};
